import logging from '@sstdev/lib_logging';
// Allows inline styles (necessary for styled-components)
// https://github.com/styled-components/styled-components/issues/887#issuecomment-376858712
 
window.__webpack_nonce__ = window.NONCE_ID;
/*
The webpack style-loader actually does something a little different when it sees
an imported CSS file (e.g. `import 'bourgyStyles.css';`) in a module. The generated
code ends up having `__webpack_require__.nc` instead of `__webpack_nonce__` 🤷‍♂️
This is really confusing if you look at the mapped source code while it is running
because it looks like it is using `__webpack_nonce__`, but the REAL code actually
does NOT. To get around that, this code sets both `__webpack_require__.nc`
and `__webpack_nonce__`.
Reference: https://github.com/styled-components/styled-components/issues/887#issuecomment-789051197
*/
//eslint-disable-next-line no-undef
__webpack_require__.nc = window.__webpack_nonce__;

 
logging.debug('[NONCE] reading globalThis.NONCE_ID: ', window.NONCE_ID);
 
logging.debug('[NONCE] setting __webpack_nonce__ = ', window.__webpack_nonce__);
